import { QueryClient } from "@tanstack/react-query";

/**
 * Single TanStack Query client for the SPA.
 *
 * Defaults reflect the shape of orchestrator data:
 * - `staleTime: 30s` — agent runs change on the order of seconds, not
 *   sub-second; aggressive refetching wastes bandwidth.
 * - `retry: 1` — the orchestrator is the same host as the SPA in prod
 *   (`api.prospect.solutions`); a transient network blip is rare and a
 *   single retry is enough to paper over it without masking real errors.
 * - `refetchOnWindowFocus: false` — admin users tab between job detail
 *   and other tools constantly; auto-refetching every focus would flood
 *   the API.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
